module.exports = ".container {\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background: #eee; }\n  .container .inner {\n    text-align: left;\n    padding: 20px; }\n  .container .inner .header h1,\n    .container .inner .header button {\n      display: inline-block; }\n  .container .inner .header button {\n      float: right; }\n  .action_btn {\n  min-width: 36px;\n  padding: 0;\n  margin: 0;\n  color: #666; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/views/organization-fonts-view/organization-fonts-view.component.scss
// module id = ./src/app/components/views/organization-fonts-view/organization-fonts-view.component.scss
// module chunks = main